"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanField = exports.integerField = exports.numberFieldWithMinZero = exports.stringField = exports.JSONSchemaType = void 0;
var JSONSchemaType;
(function (JSONSchemaType) {
    JSONSchemaType["BOOLEAN"] = "boolean";
    JSONSchemaType["INTEGER"] = "integer";
    JSONSchemaType["NULL"] = "null";
    JSONSchemaType["NUMBER"] = "number";
    JSONSchemaType["OBJECT"] = "object";
    JSONSchemaType["STRING"] = "string";
})(JSONSchemaType = exports.JSONSchemaType || (exports.JSONSchemaType = {}));
;
const { STRING, INTEGER, NUMBER, BOOLEAN, } = JSONSchemaType;
exports.stringField = {
    type: STRING
};
exports.numberFieldWithMinZero = {
    type: NUMBER,
    minimum: 0
};
exports.integerField = {
    type: INTEGER,
};
exports.booleanField = {
    type: BOOLEAN,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvanNvblNjaGVtYS9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLGNBT1g7QUFQRCxXQUFZLGNBQWM7SUFDdEIscUNBQW1CLENBQUE7SUFDbkIscUNBQW1CLENBQUE7SUFDbkIsK0JBQWdCLENBQUE7SUFDaEIsbUNBQWtCLENBQUE7SUFDbEIsbUNBQWtCLENBQUE7SUFDbEIsbUNBQWtCLENBQUE7QUFDdEIsQ0FBQyxFQVBXLGNBQWMsR0FBZCxzQkFBYyxLQUFkLHNCQUFjLFFBT3pCO0FBQUEsQ0FBQztBQUVGLE1BQU0sRUFDRixNQUFNLEVBQ04sT0FBTyxFQUNQLE1BQU0sRUFDTixPQUFPLEdBQ1YsR0FBRyxjQUFjLENBQUM7QUFFTixRQUFBLFdBQVcsR0FBRztJQUN2QixJQUFJLEVBQUUsTUFBTTtDQUNmLENBQUM7QUFFVyxRQUFBLHNCQUFzQixHQUFHO0lBQ2xDLElBQUksRUFBRSxNQUFNO0lBQ1osT0FBTyxFQUFFLENBQUM7Q0FDYixDQUFDO0FBRVcsUUFBQSxZQUFZLEdBQUc7SUFDeEIsSUFBSSxFQUFFLE9BQU87Q0FDaEIsQ0FBQztBQUVXLFFBQUEsWUFBWSxHQUFHO0lBQ3hCLElBQUksRUFBRSxPQUFPO0NBQ2hCLENBQUMifQ==